import { getAuth } from "firebase/auth";

class FirebaseService {
	callFunction = async (functionName, data = {}, customHeaders = {}) => {
		const url = `${process.env.REACT_APP_FUNCTIONS_BASE_URL}/${functionName}`
		
		// Set up headers
    const headers = {
      'Content-Type': 'application/json',
      ...customHeaders
    };
    
    // Add authentication token if user is logged in
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      try {
        const token = await user.getIdToken();
        headers['Authorization'] = `Bearer ${token}`;
      } catch (error) {
        // console.error('Error getting auth token:', error);
      }
    } 

		const fetchOptions = {headers}
		if (Object.keys(data).length === 0) {
			fetchOptions.method = 'GET'
		} else {
			fetchOptions.method = 'POST'
			fetchOptions.body = JSON.stringify(data)
		}

		try {
      const response = await fetch(url, fetchOptions);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const jsonResp = await response.json();
			// console.log(jsonResp);
			return jsonResp;
    } catch (error) {
      // console.error(`Error calling function ${functionName}:`, error);
      throw error;
    }
	}
}
// Create a singleton instance
const firebaseService = new FirebaseService();
export default firebaseService;